import React, { useEffect } from "react";
import FiltrosFilaCobranca from "./filtros-whatsapp";
import ListInfos from "./list-info-whats";
import ListInfoDadosFila from "./list-info-dados-fila";
import TabelaCobranca from "./tabela-cobranca-whats";
import { useOperador } from "../../context/OperadorContext";
import { ModalErro } from "../Modal/components/erro";
import moment from "moment";
import jwtDecode from "jwt-decode";
import { useAuth } from "../../context/AuthContext";

interface FilaCobrancaProps {
  handleOpenTab: (value: string) => void;
}

export default function FilaCobranca({ handleOpenTab }: FilaCobrancaProps) {
  const { loadData, data, loading, filtros, loadCampanhas } = useOperador();
  const { cookies, } = useAuth()
  const decoded = jwtDecode(cookies?.token || '') as any;
  useEffect(() => {
    loadData({
      ...filtros,
      data_producao: moment(new Date())
        .tz("America/Sao_Paulo")
        .format("YYYY-MM-DD")
    });
    loadCampanhas(decoded?.id_loja)
  }, []);

  return (
    <div className="flex max-h-full min-h-full  w-[99.9%] flex-col items-center rounded-md bg-white px-6 py-6">
      <div className="flex w-full items-center justify-center">
        <p className="font-bold text-coolGray-600 text-lg">CARTEIRA TOTAL - LOJA (OPERADOR LOJA) - FILIAL {decoded?.id_loja}</p>
      </div>
      <ListInfos data={data} />
      <FiltrosFilaCobranca />
      <ListInfoDadosFila data={data} />
      <TabelaCobranca
        data={data}
        handleOpenTab={handleOpenTab}
        loading={loading}
      />
      <ModalErro />
    </div>
  );
}
